import * as THREE from 'three';

export default class Card {
    PREFAB_MATERIAL = new THREE.MeshBasicMaterial({
        color: 0x000000,
        opacity: 0,
        alphaTest: 0.1,
        depthTest: false,
        transparent: true,
        // depthWrite: false,
        side: THREE.DoubleSide,
    });
    constructor({ scene }) {
        this.scene = scene;

        this.initialize();
    }

    initialize() {
        this.geometry = new THREE.PlaneGeometry( 1, 1 );

        this.uniforms = {
            time: new THREE.Uniform(1.),
            map: new THREE.Uniform(),
            ratio: new THREE.Uniform(1),
            reversed: new THREE.Uniform(0)
        };

        this.material = new THREE.ShaderMaterial( {
            side: THREE.DoubleSide,
            transparent: true,
            alphaToCoverage: true,
            uniforms: this.uniforms,
            depthWrite: false,
            vertexShader: `
                uniform float ratio;
                uniform float reversed;
                varying vec2 vUv;
                varying vec2 sUv;

                vec2 responsive(vec2 res, float diffuseAspect) {
                    float ratio = res.x / res.y / diffuseAspect;
                    float direction = step(1.0, ratio);
                    return vec2(mix(ratio, 1.0, direction), mix(1.0, 1.0 / ratio, direction));
                }
                vec2 backgroundCenter(vec2 uv, vec2 res, float diffuseAspect) {
                    vec2 resp = responsive(res, diffuseAspect);
                    return uv * resp + ((1.0 - resp) * 0.5);
                }

                void main()	{
                    vUv = uv;
                    vec2 temp_sUv = backgroundCenter(uv, vec2(1.), ratio);
                    sUv = mix(temp_sUv, vec2(1. - temp_sUv.x, temp_sUv.y), reversed);
                    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
                }
            `,
            
            fragmentShader: `
                varying vec2 vUv;
                varying vec2 sUv;

                uniform float time;
                uniform sampler2D map;

                float sdRoundBox( in vec2 p, in vec2 ra, in float rb )
                {
                    p = abs(p) - ra;
                    p = max(p,p.yx-rb);
                    float a = 0.5*(p.x+p.y);
                    float b = 0.5*(p.x-p.y);
                    return a - sqrt(rb*rb*0.5-b*b);
                }

                void main()	{
                    vec4 texel = texture2D(
                        map,
                        sUv
                    );
                    float rb = 0.25;
                    float pas = 0.008;
                    float d = sdRoundBox(vUv * 2. - 1.0, vec2(1. - rb - pas, 1. - rb - pas), rb);

                    float fw = fwidth(d);

                    float alpha = 1.0 - smoothstep(-fw, fw, d);
                    gl_FragColor = vec4(mix(vec3(0.89453125), texel.rgb, texel.a), alpha);
                }
            `
        });

        this.mesh = new THREE.Mesh( this.geometry, this.material );
        this.clone = new THREE.Mesh( this.geometry, this.PREFAB_MATERIAL );
        this.group = new THREE.Group();
        this.group = new THREE.Group();
        this.leaf = new THREE.Group();
        this.leaf.add( this.mesh );
        this.leaf.add( this.clone );
        this.group.add( this.leaf );
        this.scene.add( this.group );
    }

    handleResize() {
    }

    setDebug(pane) {
    }

    dispose() {
        this.scene.remove( this.group );
        this.geometry.dispose();
        this.material.dispose();
    }
}
